module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "upload-filelist",
    class: {
      'no-data': _vm.list.length == 0
    }
  }, [_c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('rt-icon', {
    attrs: {
      "name": _vm.titleIcon,
      "color": "#fff",
      "size": "24"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("\n        " + _vm._s(_vm.title) + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_vm._t("right-top", function() {
    return [(_vm.showButtons) ? _c('el-upload', {
      ref: "upload",
      attrs: {
        "show-file-list": false,
        "on-success": _vm.handleSuccess,
        "before-upload": _vm.beforeUpload,
        "http-request": _vm.uploadFile,
        "file-list": _vm.fileList,
        "action": ""
      }
    }, [_c('rt-button', {
      attrs: {
        "icon-name": "rt-base-upload",
        "type": "primary"
      }
    }, [_vm._v("\n            " + _vm._s(_vm.$tx("上传文件", "xpc.uploadfile.uploadfile")) + "\n          ")])], 1) : _vm._e()]
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [(_vm.list.length > 0) ? _c('el-table', {
    attrs: {
      "data": _vm.list,
      "stripe": "",
      "border": ""
    }
  }, [(_vm.showRemark) ? _c('el-table-column', {
    attrs: {
      "label": _vm.$tx('Attachment Type', 'xpc.uploadfile.type'),
      "sortable": "",
      "prop": "remark"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(!scope.row.isEdit) ? _c('p', [_vm._v("\n            " + _vm._s(scope.row.remark) + "\n          ")]) : _c('div', {
          staticClass: "cell-box"
        }, [_c('el-input', {
          attrs: {
            "placeholder": _vm.$tx('请填写备注', 'xpc.uploadfile.remarkplaceholder'),
            "type": "textarea"
          },
          model: {
            value: (scope.row.remark),
            callback: function($$v) {
              _vm.$set(scope.row, "remark", $$v)
            },
            expression: "scope.row.remark"
          }
        })], 1)]
      }
    }], null, false, 1708758508)
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$tx('文件名称', 'xpc.uploadfile.filename'),
      "sortable": "",
      "prop": "name",
      "width": "300"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(
          _vm.uploadFlag == true &&
          scope.row.uploadPercent > 0 &&
          scope.row.uploadPercent != 100
        ) ? _c('div', {
          staticClass: "progress-box"
        }, [_c('el-progress', {
          attrs: {
            "percentage": scope.row.uploadPercent,
            "show-text": false
          }
        }), _vm._v(" "), _c('p', {
          staticClass: "progress"
        }, [_vm._v("\n              " + _vm._s(_vm.$tx(
          ("已上传" + (scope.row.uploadPercent)),
          "xpc.uploadfile.uploaded", {
            count: scope.row.uploadPercent,
          }
        )) + "%\n            ")])], 1) : _vm._e(), _vm._v(" "), (scope.row.name) ? _c('p', [_vm._v("\n            " + _vm._s(scope.row.name) + "\n          ")]) : _vm._e()]
      }
    }], null, false, 2718251986)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$tx('文件大小', 'xpc.uploadfile.filesize'),
      "sortable": "",
      "prop": "size",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.size) ? _c('p', [_vm._v("\n            " + _vm._s(scope.row.size) + "\n          ")]) : _vm._e()]
      }
    }], null, false, 1999165381)
  }), _vm._v(" "), (_vm.showTitle) ? _c('el-table-column', {
    attrs: {
      "label": _vm.$tx('标题', 'xpc.uploadfile.title'),
      "sortable": "",
      "prop": "title"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(!scope.row.isEdit) ? _c('p', [_vm._v("\n            " + _vm._s(scope.row.title) + "\n          ")]) : _c('div', {
          staticClass: "cell-box"
        }, [_c('el-input', {
          attrs: {
            "placeholder": _vm.$tx('请填写标题名称', 'xpc.uploadfile.titleplaceholder')
          },
          model: {
            value: (scope.row.title),
            callback: function($$v) {
              _vm.$set(scope.row, "title", $$v)
            },
            expression: "scope.row.title"
          }
        })], 1)]
      }
    }], null, false, 2010385863)
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$tx('操作', 'xpc.uploadfile.operate'),
      "sortable": "",
      "prop": "operation",
      "align": "left",
      "min-width": "120",
      "width": "300"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "operation"
        }, [_c('rt-list-button-group', {
          ref: "buttonGroup",
          attrs: {
            "max-btns": 5
          }
        }, [_c('rt-tooltip', {
          attrs: {
            "content": _vm.$tx('编辑', 'xpc.uploadfile.edit'),
            "placement": "top"
          }
        }, [(!scope.row.isEdit &&
          _vm.showEdit) ? _c('rt-button', {
          attrs: {
            "icon-name": "rt-base-edit",
            "text": "",
            "type": "plain"
          },
          on: {
            "click": function($event) {
              return _vm.edit(scope.$index, scope)
            }
          }
        }) : _vm._e()], 1), _vm._v(" "), _c('rt-tooltip', {
          attrs: {
            "content": _vm.$tx('保存', 'xpc.uploadfile.save'),
            "placement": "top"
          }
        }, [(scope.row.isEdit && _vm.showEdit) ? _c('rt-button', {
          attrs: {
            "icon-name": "rt-base-save-lined",
            "text": "",
            "type": "plain"
          },
          on: {
            "click": function($event) {
              return _vm.save(scope.$index, scope)
            }
          }
        }) : _vm._e()], 1), _vm._v(" "), _c('rt-tooltip', {
          attrs: {
            "content": _vm.$tx('预览', 'xpc.uploadfile.preview'),
            "placement": "top"
          }
        }, [(scope.row.isReview) ? _c('rt-button', {
          attrs: {
            "icon-name": "rt-base-eye-lined",
            "text": "",
            "type": "plain"
          },
          on: {
            "click": function($event) {
              return _vm.review(scope.$index, scope)
            }
          }
        }) : _vm._e()], 1), _vm._v(" "), _c('rt-tooltip', {
          attrs: {
            "content": _vm.$tx('下载', 'xpc.uploadfile.download'),
            "placement": "top"
          }
        }, [(_vm.showDownload) ? _c('rt-button', {
          attrs: {
            "icon-name": "rt-base-download-lined",
            "text": "",
            "type": "plain"
          },
          on: {
            "click": function($event) {
              return _vm.download(scope.$index, scope)
            }
          }
        }) : _vm._e()], 1), _vm._v(" "), _c('rt-tooltip', {
          attrs: {
            "content": _vm.$tx('删除', 'xpc.uploadfile.delete'),
            "placement": "top"
          }
        }, [(_vm.showDelete) ? _c('rt-popconfirm', {
          attrs: {
            "placement": "bottom-end",
            "title": _vm.$tx(
              '确定需要删除这条内容吗？',
              'xpc.uploadfile.confirmdelete'
            )
          },
          on: {
            "confirm": function($event) {
              return _vm.onConfirm(scope.row.name, scope.$index)
            }
          }
        }, [_c('rt-button', {
          attrs: {
            "slot": "reference",
            "icon-name": "rt-base-delete",
            "text": "",
            "type": "plain"
          },
          slot: "reference"
        })], 1) : _vm._e()], 1)], 1)], 1)]
      }
    }], null, false, 460119732)
  })], 1) : _vm._t("empty", function() {
    return [_c('rt-default-image', {
      attrs: {
        "size": "medium"
      }
    }, [_c('div', {
      attrs: {
        "slot": "describe"
      },
      slot: "describe"
    }, [_vm._v("\n          " + _vm._s(_vm.$tx("暂无数据", "xpc.uploadfile.nodata")) + "\n        ")])])]
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5b45d7f3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/uploadFilelist/rtUploadFilelist.vue
// module id = 2152
// module chunks = 137